import React, { useState } from "react";

type FaqItem = { q: string; a: string };

const DATA: FaqItem[] = [
  {
    q: "How do I sign up for the FunderLand?",  
    a: `Click the “Sign Up” button on the homepage and complete the registration form. You’ll need to verify your email address before accessing full features.`,
  },
  { q: "How do I sign up for the FunderLand?", a: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quas obcaecati doloribus, corrupti mollitia labore repellendus! Quasi suscipit mollitia iure quam." },
  { q: "How do I sign up for the FunderLand?", a: "ipsum dolor sit amet consectetur adipisicing elit. Quas obcaecati doloribus, corrupti mollitia labore repellendus! Quasi suscipit mollitia iure quam." },
  { q: "How do I sign up for the FunderLand?", a: "ipsum dolor sit amet consectetur adipisicing elit. Quas obcaecati doloribus, corrupti mollitia labore repellendus! Quasi suscipit mollitia iure quam." },
  { q: "How do I sign up for the FunderLand?", a: "ipsum dolor sit amet consectetur adipisicing elit. Quas obcaecati doloribus, corrupti mollitia labore repellendus! Quasi suscipit mollitia iure quam." },
];

export default function FAQ() {
  const [open, setOpen] = useState<number>(0);
  const toggle = (i: number) => setOpen((cur) => (cur === i ? -1 : i));

  return (
    <section className="bg-[#EAF7EC]">
      <div className="mx-auto max-w-[980px] px-6 md:px-8 pt-14 pb-16">
        {/* Title */}
        <h2 className="text-center text-[40px] leading-[44px] font-bold mb-10">
          Frequently Asked Questions
        </h2>

        {/* List */}
        <ul className="flex flex-col gap-6">
          {DATA.map((item, i) => {
            const isOpen = open === i;
            return (
              <li key={i} className="select-none">
                <div className="flex items-center justify-between gap-6">
                  {/* Question */}
                  <button
                    onClick={() => toggle(i)}
                    aria-expanded={isOpen}
                    className="text-left flex-1"
                  >
                    <p className="text-base leading-[20px] font-bold text-[#0F172A]">
                      {item.q}
                    </p>
                  </button>

                  {/* +/- circular icon */}
                  <button
                    onClick={() => toggle(i)}
                    aria-label={isOpen ? "Collapse" : "Expand"}
                    className={[
                      "grid place-items-center h-9 w-9 rounded-full",
                      "border border-[#6BAF7A] text-[#0F172A]",
                      "transition-colors hover:bg-white/40 focus:outline-none",
                    ].join(" ")}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                      <path
                        d="M3 8h10"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                      />
                      {!isOpen && (
                        <path
                          d="M8 3v10"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                        />
                      )}
                    </svg>
                  </button>
                </div>

                {/* Answer */}
                {isOpen && item.a && (
                  <p className="mt-2 pl-[2px] pr-10 text-sm leading-[18px] text-[#0F172A]/70">
                    {item.a}
                  </p>
                )}
              </li>
            );
          })}
        </ul>

        {/* Bottom CTA block */}
        <div className="pt-16 text-center">
          <h3 className="text-2xl leading-[26px] font-semibold text-[#0F172A]">
            Still have questions?
          </h3>
          <p className="mt-3 text-[20px] leading-[20px]">
            Can’t find question you’re looking for? Contact your team
          </p>
          <button
            className="mt-5 inline-flex h-8 items-center rounded-[6px] bg-primary p-4 text-sm font-medium text-[#0F172A] shadow-sm hover:brightness-95"
          >
            Contact us
          </button>
        </div>
      </div>
    </section>
  );
}
